// Expected headcount (2026-11-04): who will be in the room, against the venue.
// The RSVP tiles count invite rows; this is the one place that counts people —
// investors, their +1s and the WPI staff working the event. The rules live in
// api/src/services/symposium-headcount.ts.
import { SectionCard } from '@/components/ui'
import { num } from '@/lib/format'

export interface HeadcountKpis {
  rsvpYes: number
  rsvpMaybe: number
  rsvpYesSeats: number
  rsvpYesGuests: number
  staffWorking: number
  staffWorkingTbd: number
  staffOtherAttending: number
  totalOnSite: number
}

function Seat({ value, label, total, warn }: { value: number; label: string; total?: boolean; warn?: boolean }) {
  return (
    <div className={`sym-seat${total ? ' sym-seat--total' : ''}`}>
      <span className={`sym-seat-v num${warn ? ' sym-open' : ''}`}>{num(value)}</span>
      <span className="sym-seat-l">{label}</span>
    </div>
  )
}

export function HeadcountCard({ kpis, capacity, onOpenStaff }: {
  kpis: HeadcountKpis
  capacity: number | null | undefined
  onOpenStaff: () => void
}) {
  const left = capacity != null ? capacity - kpis.totalOnSite : null
  const notCounted = [
    kpis.staffWorkingTbd > 0 && `${num(kpis.staffWorkingTbd)} WPI staff still TBD`,
    kpis.rsvpMaybe > 0 && `${num(kpis.rsvpMaybe)} Maybe`,
  ].filter(Boolean).join(' · ')

  return (
    <SectionCard eyebrow="Who will be in the room" title={<>Expected <b>Headcount</b></>}>
      <div className="sym-seats">
        <Seat value={kpis.rsvpYes} label="Investor RSVPs" />
        <Seat value={kpis.rsvpYesGuests} label="Their +1 guests" />
        <Seat value={kpis.staffWorking} label="WPI staff working" />
        {kpis.staffOtherAttending > 0 && <Seat value={kpis.staffOtherAttending} label="Other WPI attending" />}
        <Seat value={kpis.totalOnSite} label="Total on site" total />
        {capacity != null && left != null && (
          <Seat
            value={capacity}
            label={left < 0 ? `Capacity · ${num(-left)} over` : `Capacity · ${num(left)} left`}
            warn={left < 0}
          />
        )}
      </div>
      <p className="sym-headcount-note">
        {notCounted && <>Not counted yet: {notCounted}. </>}
        <button className="sym-tl-link" onClick={onOpenStaff}>Open the WPI Staff list</button>
      </p>
    </SectionCard>
  )
}
